import React from 'react';
import './ant-steps.styl';
import AntSteps from 'antd/lib/steps';
import {Step} from './Step';

export default class Steps extends React.Component {
	render() {
		return <AntSteps {...this.props} />;
	}
}

Steps.Step = Step;